import { type SlotConfig } from '../../models';
import { context } from '../../services';

export function isHidingPlaceholderEnabled(slotConfig: SlotConfig): boolean {
	return (
		context.get('state.condition.hide.slot.placeholder') &&
		!!slotConfig?.hideTopPlaceholderOnUapAndRuap
	);
}
